import { RouteType } from "types/RouteType";
// import jobDashboardRoute from "./JobDashboard/jobDashboard.Route";
import projectDashboardRoute from "./ProjectDashboard/ProjectDashboard.Route";
import jobPanelCountsRoute from "./JobPanelCounts/jobPanelCounts.Route";
import jobGanttChartRoute from "./JobGanttChart/JobGanttChart.Route";
import pmTrackerRoute from "./PmTracker/PmTracker.Route";
// import pcsRoute from "./PCS/pcs.Route";

const projectManagementRoutesList: RouteType[] = [
    // Premier's PM workbook as a dashboard (2026-10-19).
    pmTrackerRoute,
    // ...jobDashboardRoute,
    ...projectDashboardRoute,
    jobPanelCountsRoute,
    ...jobGanttChartRoute,
    // pcsRoute,
];

export default projectManagementRoutesList;
